import { Box, Spinner } from '@chakra-ui/react'
import { DDSTheme, ddsTokens } from '@ds/index'

const ChartSpinner = () => {
	const tokens = ddsTokens[DDSTheme.light]

	const overlayBgColor = tokens.primitive.light.white[100] + 'B3'

	return (
		<Box
			position="absolute"
			top="0"
			left="0"
			right="0"
			bottom="0"
			display="flex"
			alignItems="center"
			justifyContent="center"
			backgroundColor={overlayBgColor}
			zIndex="docked"
			borderRadius="inherit"
		>
			<Spinner
				thickness="4px"
				speed="0.65s"
				emptyColor={tokens.primitive.light.gray[200]}
				color={tokens.primitive.light.primary[500]}
				size="xl"
			/>
		</Box>
	)
}

export default ChartSpinner
